var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{ref:"wrapperRef",tag:"DynamicElement",staticClass:"height-transition",style:(_vm.style)},[_c(_vm.contentTag,{ref:"contentRef",tag:"DynamicElement",staticClass:"height-transition__content",class:_vm.contentClass},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }